export default "__VITE_ASSET__Cttf7AmG__"